import {
    FETCH_CREATE_USER,
    LIST_CREATE_USER
} from "./types";

const init = {
    isLoading: false,
    list: [],
    page: 1,
    size: 10,
    total: 0
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_CREATE_USER:
            return {
                ...state,
                isLoading: true
            };
        case LIST_CREATE_USER:
            return {
                ...state,
                list: payload,
                ...payload.paging,
                isLoading: false
            };
        default:
            return state;
    }
}